export const styles = {
	textField: {
		'& .MuiOutlinedInput-root': {
			'& .MuiOutlinedInput-notchedOutline': {
				borderColor: 'black',
				opacity: '23%',
			},
		},
		'& .MuiInputBase-input': {
			boxSizing: 'content-box',
			height: '100%',
		},
	},
	chip: (selected: boolean) => ({
		'&.MuiChip-root:hover': {
			backgroundColor: selected ? '#C5CAE9' : 'rgba(231, 248, 255, 0.4)',
		},
		backgroundColor: selected ? '#D6D4FF' : 'white',
		paddingX: '0.5rem',
		color: 'black',
	}),
	inputLabel: {
		color: 'black',
		opacity: '23%',
	},
	sideBar: {
		display: { xs: 'none', sm: 'block' },
		minWidth: '4px',
		background:
			'linear-gradient(180deg, rgba(0, 37, 230, 0.9) -12.94%, rgba(39, 35, 249, 0.5) 100%)',
	},
	header: {
		marginY: '2rem',
	},
	checkbox: {
		paddingLeft: '9px',
	},
	checkboxText: { color: 'black', fontSize: '16px' },
	text: {
		color: 'black',
	},
	asterisk: {
		color: 'rgba(211, 47, 47, 1)',
		marginLeft: '8px',
	},
	mainContainer: {
		display: 'flex',
		flexDirection: 'column',
		rowGap: '3rem',
		flexGrow: 1,
	},
	questionContainer: {
		display: 'inline-flex',
		alignItems: 'center',
	},
	stakeholderSelector: {
		display: 'flex',
		columnGap: '2rem',
		rowGap: '1rem',
		flexWrap: 'wrap',
		marginTop: '1rem',
	},
	buttonContainer: {
		display: 'flex',
		flexDirection: {
			xs: 'column',
			sm: 'row',
		},
		gap: '2rem',
	},
}
